import { i18n } from '@/locales';
const lc = 'views.delivery_charge_area_control.registered_area.';
export default [
    {
        title: i18n.t(`${lc}area_name`),
        sortable: false,
        value: 'areaName',
    },
    {
        title: '',
        value: 'areaConfig',
        align: 'end',
        sortable: false,
        width: 100,
    },
];
